import React = require("react");
import {Stylable} from "../common/PropsType";
import "./veboxLoginCard.scss"

const VeBoxLoginCardComponent: React.FC<Stylable> = (props) => {
    return (
        <div className={"vebox-login-card " + (props.className ?? "")}>
            {props.children}
        </div>
    )
};

interface TitleProps extends Stylable {
    text: string
}

const Title: React.FC<TitleProps> = (props) => {
    return (
        <span className={"vebox-title " + (props.className ?? "")} style={props.style}>{props.text}</span>
    );
};


const Header: React.FC<Stylable> = (props) => {
    return (
        <div className={"vebox-login-card-header " + (props.className ?? "")} style={props.style}>
            <div className={"vebox-login-card-title"}>
                {props.children}
            </div>
            <hr className={"vebox-login-card-divider"}/>
        </div>
    );
};

const Body: React.FC<Stylable> = (props) => {
    return (
        <div className={"vebox-login-card-body " + (props.className ?? "")}>
            {props.children}
        </div>
    );
};
const Footer: React.FC<React.HTMLAttributes<any>> = (props) => {
    return (
        <div {...props} className={"vebox-login-card-footer " + (props.className ?? "")}>
            {props.children}
        </div>
    );
};

/* tslint:disable */
export const VeBoxLoginCard = Object.assign(VeBoxLoginCardComponent, {
    Header,
    Body,
    Footer,
    Title
});
